module.exports = __webpack_public_path__ + "assets/oil-life.b770144e.svg";